import * as angular from "angular";
import { DialogUtils } from "../../../../helper/dialog.helper";
import { ToastUtils } from "../../../../helper/toast.helper";
import { DashboardDataProvider } from "../../../../data-provider/dashboard.dp";
import { Group } from "../../../../models/group.model";
import { GroupDataProvider } from "../../../../data-provider/group.dp";
import { User } from "../../../../models/user.model";
import * as _ from "lodash";

let WidgetFilterListsDialogComponent = {
    selector: "vcWidgetFilterListsDialog",
    templateUrl:
        "/angular/components/dashboard/widget/filter/widget-filter-lists-dialog.component.html",
    bindings: {
        filter: "=",
    },
    controller: class WidgetFilterListsDialogController {
        // * bindings for typescript compiler *
        public filter: any;
        // ************************************
        public saving: boolean = false;
        public dialog: DialogUtils;
        public toast: ToastUtils;
        public dataProvider: DashboardDataProvider;
        public type: string = "team";
        public groups: Group[];

        constructor(
            DashboardDataProvider: DashboardDataProvider,
            GroupDataProvider: GroupDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = DashboardDataProvider;

            GroupDataProvider.getAllGroups().then((groups: Group[]) => {
                this.groups = groups;
            });
        }

        toggle(item: string, list: any[]) {
            let idx: number = -1;

            angular.forEach(list, (thisList: User, $index: number) => {
                if (thisList["gid"] && item["gid"] == thisList["gid"]) {
                    idx = $index;
                }
            });

            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push({ gid: item["gid"], gname: item["gname"] });
            }
        }

        exists(item: string, list: string | any[]) {
            let found: boolean = false;

            angular.forEach(list, (thisList: User, $index: number) => {
                if (thisList["gid"] && item["gid"] == thisList["gid"]) {
                    found = true;
                }
            });
            return found;
        }

        $onInit() {}

        cancel() {
            this.dialog.cancel();
        }

        save() {
            this.saving = true;
            this.dialog.hide(this.filter);
        }
    },
};

angular
    .module("dashboard")
    .component(
        WidgetFilterListsDialogComponent.selector,
        WidgetFilterListsDialogComponent
    );
